import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Location} from '@angular/common';
import {IOption} from 'ng-select';
import * as _ from 'underscore';
import {Router, ActivatedRoute} from '@angular/router';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {DataService} from '../../shared/data.service';
import {FormDataService} from '../../shared/form-data.service';
import {RightSideService} from '../../shared/right-side.service';
import {Brand} from '../../shared/classes/brand.model';
import {ProductModel} from '../../shared/classes/product-model.model';
import {NavigationBarService} from '../../shared/navigation-bar.service';
import {PageContent} from '../../shared/classes/page-content.model';
import {Category} from '../../shared/classes/category.model';
import {mapsTurkishCharToEnglishChar} from '../../../../app.component';
import {storageFactory, detectmob} from '../../../../app-storage';
import hbusApiClient from '../../../../analytics/hbusApiClient';

@Component({
  selector: 'app-first-tab',
  templateUrl: './first-tab.component.html',
  styleUrls: ['./first-tab.component.css', '../second-tab/second-tab.component.css'],
  host: {
    class: 'col-12 col-sm-12 col-md-9 col-lg-9',
  }

})
export class FirstTabComponent implements OnInit, AfterViewInit {
  tabSelected = 1;
  errorTexts: string[] = [];
  selectedBrand = false;
  selectedModel = false;
  category: Category;
  brandId: number;
  pageContent: PageContent;
  categoryId: number;
  brands: Array<IOption> = [];
  models: Array<IOption> = [];
  twinModels: Array<IOption> = [];
  firstForm: FormGroup;
  firstTabResultViewed = false;
  isIOS: boolean;
  cashbackEnabled = false;
  cashbackSelected = false;
  features = [];
  selectedFeatures = {};
  categoryName: string;

  constructor(
    private location: Location,
    private tabsService: RightSideService,
    private selectBoxService: DataService,
    private formDataService: FormDataService,
    public rightSideService: RightSideService,
    private navBarService: NavigationBarService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.categoryName = this.tabsService.getCategoryName();
    this.isIOS = (storageFactory(localStorage).getItem('isIOS') === 'true');
    this.firstTabResultViewed = this.rightSideService.isResultViewed;
    this.rightSideService.isResultViewed = false;

    this.firstForm = new FormGroup({
      brand: new FormControl('', Validators.required),
      model: new FormControl('', Validators.required),
    });

    this.rightSideService.cashbackEnabledChange.subscribe(val => {
      this.cashbackEnabled = this.rightSideService.getCashbackEnabled();
    });

    this.cashbackSelected = this.rightSideService.getCashbackSelected();

    this.rightSideService.pageContentChange.subscribe(val => {
      this.pageContent = this.rightSideService.getPageContent();
    });
  }

  ngAfterViewInit() {
    this.rightSideService.firstTab = this;
    this.scrollElement();
  }

  opened() {
    document.getElementsByClassName('filter')[0].id = 'filt';
    document.getElementById('filt').lastElementChild.id = 'inp';
    document.getElementById('inp').blur();
    this.models = this.twinModels;
  }

  scrollElement() {
    if (this.selectedModel && this.tabSelected !== 5) {
      const elmnt = document.getElementById('navHead');
      const isMobile = detectmob();
      if (isMobile) {
        if (!navigator.userAgent.match(/safari/i) || localStorage == null) {
          // safari || android webview
          parent.postMessage({
            scrollY: elmnt.getBoundingClientRect().top - 120
          }, '*');
        } else {
          // ios safari || android tarayıcı
          parent.postMessage({
            scrollY: elmnt.getBoundingClientRect().top - 60
          }, '*');
        }
      } else {
        parent.postMessage({
          scrollY: elmnt.getBoundingClientRect().top - 80
        }, '*');
      }
    }
  }

  getCategoryUrls(categoryName) {
    this.selectBoxService.getCategoryUrls().subscribe((res: any[]) => {
      const category = _.find(
        res, function (cat) {
          return mapsTurkishCharToEnglishChar(
            cat.friendlyUrl).split(' ').join('-') === mapsTurkishCharToEnglishChar(categoryName).split(' ').join('-');
        });
      if (category) {
        this.getCategory(category.categoryId, true);
        this.getPageContents();
        this.location.go(category.friendlyUrl);
      } else {
        this.getCategory(this.rightSideService.selectedCategoryId);
        this.getPageContents();
      }
    }, error => {
      error.errorMessages.forEach(err => {
        this.errorTexts.push(err);
      });
    });
  }

  getPageContents() {
    this.selectBoxService.getPageContents(this.rightSideService.selectedCategoryId).subscribe((res: PageContent) => {
      this.pageContent = this.rightSideService.createPageContent(res);
      this.rightSideService.setPageContent(this.pageContent);
    }, error => {
      error.errorMessages.forEach(err => {
        this.errorTexts.push(err);
      });
    });
  }

  getDefaultCategory(): Promise<number> {
    return new Promise((resolve, reject) => {
      this.selectBoxService.getDefaultCategory().subscribe((res: Category) => {
        this.rightSideService.selectedCategoryId = res.id;
        resolve(this.rightSideService.selectedCategoryId);
      }, error => {
        error.errorMessages.forEach(err => {
          this.errorTexts.push(err);
        });
      });
    });
  }

  getCategory(categoryId?: number, isFinded?: boolean) {
    this.selectBoxService.getCategory(this.rightSideService.selectedCategoryId).subscribe((res: Category) => {
      this.category = res;

      if (!this.rightSideService.isForwarded) {
        this.rightSideService.setCategoryName(res.name);
        this.rightSideService.setImageUrl(res.imageUrl);
        this.rightSideService.setTopImageUrl(res.topImageUrl);
        this.rightSideService.setDeci(res.deci);
      }
      this.rightSideService.setCashbackEnabled(res.isCashbackEnabled);

      const zerothValues = this.formDataService.getZerothTabData();
      if (!zerothValues && this.cashbackEnabled) {
        this.navBarService.setSelectedTab(0);
        this.router.navigate(['/']);
      }

      this.getBrands(res.id);
      this.getCategoryFeatures(res.id);
    }, error => {
      error.errorMessages.forEach(err => {
        this.errorTexts.push(err);
      });
    });
  }

  getBrands(categoryId) {
    const tmpBrands = [];
    this.selectBoxService.getBrands(categoryId).subscribe(
      (res: Brand[]) => {
        res.forEach(brand => {
          tmpBrands.push({label: brand.name, value: '' + brand.id});
        });
        this.brands = tmpBrands;
      }, error => {
        this.errorTexts.push(error);
      }
    );
  }

  getCategoryFeatures(categoryId, brandId = null) {
    this.selectBoxService.getCategoryFeatures(categoryId, brandId).subscribe(
      (res) => {
        this.features = res;
        this.features.forEach(feature => {
          this.firstForm.addControl(feature.slug, new FormControl(''));

          feature.items.forEach(item => {
            item.value = String(item.id);
            item.label = item.text;
          });
        });

        const lastValues = this.formDataService.getFirstTabData();
        if (lastValues && lastValues.brand && lastValues.model) {
          Object.keys(lastValues).forEach(key => {
            if (key !== 'brand' && key !== 'model') {
              this.firstForm.controls[key].patchValue(lastValues[key]);
              this.selectedFeatures[key] = lastValues[key];
            }
          });
        }
      }, error => {
        this.errorTexts.push(error);
      }
    );
  }

  ngOnInit() {
    const lastValues = this.formDataService.getFirstTabData();
    if (lastValues && lastValues.brand && lastValues.model && !this.firstTabResultViewed) {
      this.selectedBrand = true;
      this.selectedModel = true;
      this.firstForm.controls['brand'].patchValue('' + lastValues.brand);
      this.firstForm.controls['model'].patchValue('' + lastValues.model);
      this.getModels(lastValues.brand);
    }

    this.navBarService.setSelectedTab(1);

    if (!this.rightSideService.selectedCategoryId) {
      this.navBarService.setSelectedTab(0);
      this.router.navigate(['/']);

      return false;
    }

    this.getCategory();
    this.getPageContents();
  }

  brandSelect(event) {
    this.selectedBrand = true;
    this.firstForm.controls['model'].patchValue(null);
    this.brandId = event.value;
    this.formDataService.clear();
    this.resetRightSide();
    this.getModels(this.brandId);
    this.rightSideService.setBrandName(this.brands.find(brand => brand.value === this.brandId.toString()).label);
    this.getCategoryFeatures(this.rightSideService.selectedCategoryId, this.brandId);
  }

  resetRightSide() {
    this.rightSideService.setLabel('');
    this.rightSideService.setTopImageUrl(this.category.topImageUrl);
    this.rightSideService.setImageUrl(this.category.imageUrl);
    this.rightSideService.setResetChanged(true);
  }

  modelSelect(event) {
    this.selectedModel = true;
    this.rightSideService.selectedProductId = event.value;
    this.formDataService.clear();
    this.rightSideService.firstForm = this.firstForm;
    this.formDataService.setFirstTabData(this.firstForm.value);
    if (this.cashbackSelected) {
      this.rightSideService.setPrice(event.cashbackMaximumPrice);
    } else {
      this.rightSideService.setPrice(event.maximumPrice);
    }
    this.rightSideService.setLabel(event.label);
    this.rightSideService.setImageUrl(event.imageUrl);
    this.rightSideService.setModelName(this.models.find(model => model.value === this.rightSideService.selectedProductId.toString()).label);
    this.models = this.twinModels;
  }

  featureSelect(slug, event) {
    this.selectedFeatures[slug] = event.value;
    this.firstForm.controls['model'].patchValue(null);
    this.selectedModel = false;
    if (this.brandId) {
      this.formDataService.clear();
      this.resetRightSide();
      this.getModels(this.brandId);
    }
  }

  getModels(brandId) {
    this.selectBoxService.getModels(parseInt(brandId),
      this.rightSideService.selectedCategoryId,
      Object.values(this.selectedFeatures).join(','),
      String(this.cashbackSelected))
      .subscribe(
        (res: ProductModel[]) => {
          this.models = this.generateModelOption(res);
          this.twinModels = this.models;
        }, error => {
          this.errorTexts.push(error);
        }
      );
  }

  generateModelOption(products: ProductModel[]): IOption[] {
    const tmpModels = [];
    products.forEach(model => {
      tmpModels.push({
        label: model.name,
        value: '' + model.id,
        imageUrl: model.imageUrl,
        price: model.price,
        maximumPrice: model.maximumPrice,
        cashbackMaximumPrice: model.cashbackMaximumPrice,
        description: model.description
      });
    });
    return tmpModels;
  }

  prevStep() {
    this.navBarService.setSelectedTab(this.tabSelected - 1);
    this.sendDavinciEvent('öncekiAdım');
    this.router.navigate(['/' + this.category.friendlyUrl]);
  }

  nextStep() {
    this.rightSideService.isForwarded = true;
    this.formDataService.setFirstTabData(this.firstForm.value);
    this.navBarService.setSelectedTab(this.tabSelected + 1);
    this.sendDavinciEvent('sonrakiAdım');
    this.router.navigate(['/cihaz-durumu']);
  }

  onFilterInputChanged(searchTerm: string) {
    if (searchTerm && this.brandId) {
      this.selectBoxService.searchProduct(this.brandId,
        this.rightSideService.selectedCategoryId,
        searchTerm,
        String(this.cashbackSelected))
        .subscribe((res: ProductModel[]) => {
          if (res.length > 0) {
            this.models = this.generateModelOption(res);
          }
        }, error => {
          this.errorTexts.push(error);
        });
    } else if (!searchTerm && this.brandId) {
      this.models = this.twinModels;
    }
  }

  sendDavinciEvent(buttonName) {
    try {
      hbusApiClient.sendEventRequest('ModelSelection', {
        page_type: 'static',
        page_value: 'eskiyi-getir-yeniyi-gotur',
        stepNo: 2,
        stepName: 'ModelSelection',
        paymentOptions: this.cashbackSelected ? 'cash' : 'coupon',
        brand: this.brands && this.brands.find(brand => brand.value === this.firstForm.value.brand) ?
          this.brands.find(brand => brand.value === this.firstForm.value.brand).label
          : '',
        model: this.models && this.models.find(model => model.value === this.firstForm.value.model) ?
          this.models.find(model => model.value === this.firstForm.value.model).label
          : '',
        proposedAmount: this.rightSideService.getPrice() ?
          `${(this.rightSideService.getPrice()).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
          : '',
        buyBackCategory: this.categoryName || '',
        clickButtonInfo: buttonName,
      });
    } catch (e) {
      console.error('error send message', e.message);
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/tabs/first-tab/first-tab.component.ts